<template>
    <div class="VLine-block">
        <div class="VLine-block__header">
            <div class="VLine-block__name">
                {{ showName }}:
            </div>
            <div class="VLine-block__select">
                Select all
                <v-checkbox
                    :checked="isSelectedAll"
                    @click="chooseAll"
                ></v-checkbox>
            </div>
        </div>
        
        <span
            class="VLine-block__no-filters"
            v-if="!items.length"
        >No {{ showName }}</span>
        <div
            class="VLine-block__section"
            v-if="items.length"
        >
            <VLabel
                v-for="(item,itemIndex) in items"
                :key="itemIndex"
                :color="item.color || '#6089E7'"
                :font-weight="item.fontWeight"
                @click="itemRemove(itemIndex)"
            >
                {{ item.name }}
            </VLabel>
        </div>
        <div
            class="VLine-block__section"
            v-if="deletedItems.length"
        >
            <VLabel
                v-for="(item,itemIndex) in deletedItems"
                :key="itemIndex"
                :color="item.color || '#6089E7'"
                :font-weight="item.fontWeight"
                action="add"
                @click="itemAdd(itemIndex)"
            >
                {{ item.name }}
            </VLabel>
        </div>
        <div
            v-if="isCanAddItem"
            class="VLine-block__add"
        >+
        </div>
    </div>
</template>

<script>
    export default {
        name: 'LineBlock',
        props: {
            items: {
                type: Array,
                required: true,
            },
            deletedItems: {
                type: Array,
                required: true,
            },
            showName: {
                type: String,
                required: true,
                default: 'Items',
            },
            isCanAddItem: {
                type: Boolean,
                default: true,
            },
            sync: {
                type: Boolean,
                default: true,
            },
        },
        methods: {
            chooseAll() {
                if (this.isSelectedAll) {
                    this.items.forEach((item, itemIndex) => {
                        this.itemRemove(itemIndex);
                    });
                } else {
                    this.deletedItems.forEach((item, itemIndex) => {
                        this.itemAdd(itemIndex);
                    });
                }
            },
            itemRemove(itemIndex) {
                if (this.sync) {
                    const newItems = this.items.filter((item) => item.name !== this.items[itemIndex].name);
                    this.$emit('update:items', newItems);
                } else {
                    this.$emit('remove', this.items[itemIndex]);
                }
            },
            itemAdd(itemIndex) {
                if (this.sync) {
                    const newItems = _.cloneDeep(this.items);
                    newItems.push(this.deletedItems[itemIndex]);
                    this.$emit('update:items', newItems);
                } else {
                    this.$emit('add', this.deletedItems[itemIndex]);
                }
            },
        },
        computed: {
            isSelectedAll() {
                return !this.deletedItems.length;
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
    .VLine-block {
        position: relative;
        margin-bottom: 16px;
        
        &__header {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        
        &__select {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 90px;
        }
        
        &__name {
            font-weight: 600;
            padding-top: 4px;
            margin-bottom: 5px;
        }
        
        &__section {
            display: flex;
            flex-wrap: wrap;
            margin-left: -5px;
            margin-right: -5px;
            margin-bottom: -5px;
            margin-top: 5px;
            
            ::v-deep {
                .VLabel {
                    margin: 5px 5px;
                }
            }
        }
        
        &__add {
            position: absolute;
            right: 5px;
            font-weight: bold;
            font-size: 27px;
            color: purple;
            cursor: not-allowed;
        }
    }
</style>
